import React, { useState, useEffect } from "react";
import avatar from "../../assets/images/img6.jpg";
import gear from "../../assets/svg/gear.svg";
import Link from "next/link";
import { Images } from "../../assets/images/Images";
import Image from "next/image";
import { getCookie } from "../../assets/js/help_func";
import ErrorFeedback from "../../pages/accounts/feedback";
import styled from "styled-components";
import { useRouter } from "next/router";

const MobileNav = (props) => {
	const router = useRouter();
	const { leads } = router.query;
	const [username, setUSername] = useState();

	const [menu, setMenu] = useState("hamburger");
	const [selected, setSelected] = useState();
	const [adminNav, setAdminNav] = useState(false);
	const [menulinks, setMenuLinks] = useState("menu_links");

	const HandleBurger = () => {
		menu === "hamburger"
			? setMenu("hamburger is-active")
			: setMenu("hamburger");

		menulinks === "menu_links"
			? setMenuLinks("menu_links active")
			: setMenuLinks("menu_links");
	};

	useEffect(() => {
		if (getCookie("u_id")) {
			setAdminNav(true);
		}
		setUSername(leads);
	});
	return (
		<ReactMainNav>
			<header>
				<div id="topNav">
					<div className="top_nav container">
						<div className="logo">
							<Image
								src={Images.logo}
								alt="instincthub logo"
								width={177}
								height={25}
							/>
						</div>

						<div className="gear_avatar">
							{adminNav ? (
								<>
									<Image
										src={
											getCookie("u_thumbnail")
												? getCookie("u_thumbnail")?.split("?")[0]
												: avatar.src
										}
										alt="avatar"
										width={41}
										height={41}
									/>
									<Link href={`/${username}/settings/`}>
										<Image
											src={gear.src}
											alt="s"
											className="settings_gear"
											width={26}
											height={26}
										/>
									</Link>
									<ErrorFeedback />
								</>
							) : (
								<li className="login_large_screen_btn">
									<Link href="/accounts/login">Login</Link>
								</li>
							)}
						</div>

						<div className={menu} onClick={HandleBurger} id="hamburger-1">
							<span className="line"></span>
							<span className="line"></span>
							<span className="line"></span>
						</div>
					</div>
				</div>
			</header>
			{adminNav ? (
				<nav className={menulinks}>
					<ul>
						<li className={props.active}>
							<Link href={`/${username}/leads`}>Lead</Link>
						</li>
						<li className={props.schedule}>
							<Link href={`/${username}/schedules`}>Schedule</Link>
						</li>
						<li className={props.downloads}>
							<Link href={`/${username}/downloads`}>Downloads</Link>
						</li>
						<li className={props.events}>
							<Link href={`/${username}/events`}>Events</Link>
						</li>
						<li className={props.newsletter}>
							<Link href={`/${username}/newsletter`}>Newsletter</Link>
						</li>
						<li className={props.career}>
							<Link href={`/${username}/careers`}>Career</Link>
						</li>
					</ul>
				</nav>
			) : (
				<nav className={menulinks}>
					<ul>
						<li>
							<Link href="https://skills.instincthub.com/"> Courses</Link>
						</li>
						<li>
							<Link href="https://instincthub.com/blog">Blog</Link>
						</li>
						<li>
							<Link href="https://instincthub.com/about">About</Link>
						</li>
						<li>
							<Link href="https://instincthub.com/about/contact">Contact</Link>
						</li>
						<li className="mobile_login">
							<Link href="/accounts/login">Login</Link>
						</li>
						<li>
							<Link href="/accounts/join">Create Leadboard</Link>
						</li>
					</ul>
				</nav>
			)}
		</ReactMainNav>
	);
};

export default MobileNav;

const ReactMainNav = styled.div`
	@media (max-width: 720px) {
		.gear_avatar {
			.login_large_screen_btn {
				display: none;
			}
		}
	}
	@media (min-width: 720px) {
		.gear_avatar {
			flex-direction: row-reverse;
		}
		.mobile_login {
			display: none;
		}
	}
`;
